import React, { useCallback, useEffect } from "react";
import UserDropdown from "@/components/auth/UserDropdown";
import LoginSignupButtons from "@/components/auth/LoginSignupButtons";
import LoadingButton from "@/components/auth/LoadingButton";
import { useAuthButton } from "@/hooks/useAuthButton";

const AuthButton = () => {
  const { loading, isLoggingOut, handleLogout, handleRetry, isAdmin, session } =
    useAuthButton();

  const memoizedHandleLogout = useCallback(handleLogout, [handleLogout]);
  const memoizedHandleRetry = useCallback(handleRetry, [handleRetry]);
  if (loading) {
    return <LoadingButton onRetry={memoizedHandleRetry} />;
  }

  if (session) {
    return (
      <UserDropdown
        isLoggingOut={isLoggingOut}
        onLogout={memoizedHandleLogout}
        isAdmin={isAdmin}
      />
    );
  }

  return <LoginSignupButtons />;
};

export default AuthButton;
